function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .link-path_svg__link-path_svg__cls-1{fill:none;stroke:#717375;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}\n    "));

var _ref2 = /*#__PURE__*/React.createElement("title", null, "\n    link\n  ");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "link-path_svg__link-path_svg__cls-1",
  d: "M14.7,21.55,10.25,26a5.31,5.31,0,0,1-7.5,0l-.45-.45a5.31,5.31,0,0,1,0-7.5l6.84-6.84a5.31,5.31,0,0,1,7.5,0l.45.45a5.3,5.3,0,0,1,1.4,2.47"
}), /*#__PURE__*/React.createElement("path", {
  className: "link-path_svg__link-path_svg__cls-1",
  d: "M13.45,6.75,17.89,2.3a5.32,5.32,0,0,1,7.51,0l.44.45a5.29,5.29,0,0,1,0,7.5L19,17.09a5.31,5.31,0,0,1-7.5,0l-.44-.45a5.19,5.19,0,0,1-1.4-2.46"
})));

function SvgLinkPath(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28.15 28.3"
  }, props), _ref, _ref2, _ref3);
}

export default SvgLinkPath;